import React from 'react'
import GrooverText from '../components/GrooverText'

export const PortalViewAsEndedPage: React.FC = () => (
  <div
    style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 12,
      padding: 24,
      textAlign: 'center'
    }}
  >
    <h1 style={{ margin: 0, fontSize: 24 }}>
      <GrooverText textKey="portalViewAsEndedTitle" />
    </h1>
    <p style={{ margin: 0, color: '#4b5563' }}>
      <GrooverText textKey="portalViewAsEndedMessage" />
    </p>
  </div>
)
